import React from 'react';
import { Color, Row, Column, Text } from '@snowflake/core-ui';

export const SignupErrorPage = () => (
  <Row height="100vh" verticalAlign="middle" align="center" backgroundColor={Color.Gray10}>
    <Column>
      <Text
        size="xxlarge"
        color={Color.Gray85}
        fontWeight={700}
        textAlign="center"
        marginBottom="0.5em"
      >
        Something went wrong
      </Text>
      <Text size="large" textAlign="center" color={Color.Gray70} marginBottom="2em">
        Please refresh the page and try again.
      </Text>
    </Column>
  </Row>
);
